import "./fonts/GlacialIndifference-Regular.otf";

export {};
